
import { timeRangeOptions, financeCurrencysOption } from "@/utils/options";

const currencyOptions = financeCurrencysOption.filter(item => item.text !== '原币种')

export default () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
},  {
    label: '品类',
    labelWidth: '120px',
    prop: 'categoryIds',
    isFormItem: true,
    components: [{
        name: 'gj-category-select',
        prop: 'categoryIds',
        propsData: {
            placeholder: '品类',
            multiple: true,
            collapseTags: true
        }
    }],
    defaultValue: []
}, {
    label: '品牌',
    labelWidth: '120px',
    prop: 'brandIds',
    isFormItem: true,
    components: [{
        name: 'gj-brand-select',
        prop: 'brandIds',
        propsData: {
            placeholder: '品牌',
            multiple: true,
            collapseTags: true
        }
    }],
    defaultValue: []
}, {
    label: '币种',
    prop: 'currency',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'currency',
        propsData: {
            options: currencyOptions,
            placeholder: '币种'
        }
    }],
    defaultValue: ''
}, {
    label: '时间范围',
    prop: 'dateRange',
    isFormItem: true,
    labelWidth: '120px',
    components: [ {
        name: 'gj-select',
        prop: 'dateRange',
        propsData: {
            placeholder: '时间范围',
            options: timeRangeOptions,
            style: {
                marginLeft: '8px'
            }
        }
    }],
    validator: [
        {required: true, message: '请选择日期', trigger: 'change'}
    ]
},]